import { gql } from "@apollo/client";

export const DELETE_API_TOKEN = gql`
  mutation DeleteAPIToken($input: DeleteAPITokenInput!) {
    deleteAPIToken(input: $input) {
      ok
    }
  }
`;
